<template>
  <div class="ele-body">
    <el-card shadow="never">
      <!-- Tab 切换 -->
      <div style="margin-bottom: 15px; padding-top: 5px">
        <el-radio-group v-model="currentTab" size="small" @change="onTabChange">
          <el-radio-button label="fixed">固定资产统计</el-radio-button>
          <el-radio-button label="consumable">易耗品统计</el-radio-button>
        </el-radio-group>
      </div>

      <!-- 固定资产统计表格 -->
      <el-table v-if="currentTab === 'fixed'" :data="fixedData" border v-loading="fixedLoading" show-summary
        :summary-method="getFixedSummary">
        <el-table-column prop="typeName" label="类别名称" align="center" show-overflow-tooltip />
        <el-table-column prop="itemCount" label="总数量" align="center" />
        <el-table-column prop="inUseCount" label="使用中" align="center">
          <template #default="{ row }">
            <span style="color: #67c23a">{{ row.inUseCount }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="unassignedCount" label="未分配" align="center">
          <template #default="{ row }">
            <span style="color: #909399">{{ row.unassignedCount }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="repairCount" label="维修中" align="center">
          <template #default="{ row }">
            <span style="color: #e6a23c">{{ row.repairCount }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="scrapCount" label="报废" align="center">
          <template #default="{ row }">
            <span style="color: #f56c6c">{{ row.scrapCount }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="lostCount" label="遗失" align="center">
          <template #default="{ row }">
            <span style="color: #f56c6c">{{ row.lostCount }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="120" fixed="right">
          <template #default="{ row }">
            <el-button type="text" size="mini" icon="el-icon-view" @click="handleViewDetail(row)">查看详情</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 易耗品统计表格 -->
      <el-table v-if="currentTab === 'consumable'" :data="consumableData" border v-loading="consumableLoading"
        show-summary :summary-method="getConsumableSummary">
        <el-table-column prop="itemName" label="物品名称" show-overflow-tooltip />
        <el-table-column prop="totalNum" label="总数量" align="center" />
        <el-table-column prop="remainingNum" label="剩余数量" align="center">
          <template #default="{ row }">
            <span style="color: #67c23a">{{ row.remainingNum }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="useNum" label="已使用数量" align="center">
          <template #default="{ row }">
            <span style="color: #e6a23c">{{ row.useNum }}</span>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <!-- 详情弹窗 -->
    <el-dialog title="资产物品详情" :visible.sync="detailDialogVisible" width="1000px" :close-on-click-modal="false">
      <!-- 搜索表单 -->
      <el-form :model="detailParams" label-width="77px" class="ele-form-search" @keyup.enter.native="handleDetailSearch"
        @submit.native.prevent>
        <el-row :gutter="15">
          <el-col :md="8" :sm="12">
            <el-form-item label="物品名称:">
              <el-input v-model="detailParams.itemName" placeholder="请输入物品名称" clearable />
            </el-form-item>
          </el-col>
          <el-col :md="8" :sm="12">
            <el-form-item label="状态:">
              <el-select v-model="detailParams.status" placeholder="请选择" clearable class="ele-fluid">
                <el-option label="未分配" :value="0" />
                <el-option label="使用中" :value="1" />
                <el-option label="维修中" :value="2" />
                <el-option label="报废" :value="3" />
                <el-option label="遗失" :value="4" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :md="8" :sm="12">
            <div class="ele-form-actions">
              <el-button type="primary" @click="handleDetailSearch" icon="el-icon-search"
                class="ele-btn-icon">查询</el-button>
              <el-button @click="handleDetailReset">重置</el-button>
              <el-button type="warning" @click="handleDetailExport" icon="el-icon-download">导出</el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <!-- 详情表格 -->
      <ele-data-table ref="detailTable" :config="detailTable" highlight-current-row>
        <template #default="{ index }">
          <el-table-column type="index" :index="index" width="50" align="center" show-overflow-tooltip />
          <el-table-column prop="itemCode" label="物品编码" show-overflow-tooltip min-width="120" />
          <el-table-column prop="itemName" label="物品名称" show-overflow-tooltip min-width="150" />
          <el-table-column prop="typeName" label="类别" show-overflow-tooltip min-width="130" />
          <el-table-column prop="roomName" label="场室" show-overflow-tooltip min-width="100" />
          <el-table-column label="状态" align="center" width="80">
            <template #default="{ row }">
              <el-tag size="mini" :type="statusTagType(row.status)">{{ statusLabel(row.status) }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="teacherName" label="分配教师" show-overflow-tooltip width="100" />
          <el-table-column prop="price" label="价格" align="center" width="90" />
          <el-table-column prop="procurementTime" label="采购日期" show-overflow-tooltip min-width="110" />
        </template>
      </ele-data-table>
    </el-dialog>
  </div>
</template>

<script>
import { statistics, statisticsDetail, exportItemDetails, consumablesStatistics } from '@/config/assetApi';

export default {
  name: 'AssetStatistics',
  data () {
    return {
      currentTab: 'fixed',
      // 固定资产统计
      fixedLoading: false,
      fixedData: [],
      // 易耗品统计
      consumableLoading: false,
      consumableData: [],
      // 详情弹窗
      detailDialogVisible: false,
      currentTypeId: null,
      detailParams: {
        itemName: '',
        status: '',
      },
      detailTable: {
        url: '/asset/statisticsDetail',
        where: {},
        parseData (res) {
          if (res.data && res.resCode == 200) {
            res.code = 0;
            res.count = res.data.total;
            res.data = res.data.records;
            return res;
          } else {
            res.code = 1;
            res.data = [];
            res.count = 0;
            return res;
          }
        },
      },
    };
  },
  created () {
    this.fetchFixedStatistics();
  },
  methods: {
    statusLabel (status) {
      const map = { 0: '未分配', 1: '使用中', 2: '维修中', 3: '报废', 4: '遗失' };
      return map[status] || '';
    },
    statusTagType (status) {
      const map = { 0: 'info', 1: 'success', 2: 'warning', 3: 'danger', 4: 'danger' };
      return map[status] || 'info';
    },
    onTabChange () {
      if (this.currentTab === 'fixed') {
        this.fetchFixedStatistics();
      } else {
        this.fetchConsumableStatistics();
      }
    },
    // 固定资产统计
    fetchFixedStatistics () {
      this.fixedLoading = true;
      statistics()
        .then((res) => {
          if (res.data && res.data.resCode == 200) {
            this.fixedData = res.data.data || [];
          } else {
            this.fixedData = [];
          }
        })
        .catch(() => {
          this.fixedData = [];
        })
        .finally(() => {
          this.fixedLoading = false;
        });
    },
    // 易耗品统计
    fetchConsumableStatistics () {
      this.consumableLoading = true;
      consumablesStatistics()
        .then((res) => {
          if (res.data && res.data.resCode == 200) {
            this.consumableData = res.data.data || [];
          } else {
            this.consumableData = [];
          }
        })
        .catch(() => {
          this.consumableData = [];
        })
        .finally(() => {
          this.consumableLoading = false;
        });
    },
    // 查看详情
    handleViewDetail (row) {
      this.currentTypeId = row.typeId;
      this.detailParams = { itemName: '', status: '' };
      this.detailTable.where = { typeId: row.typeId };
      this.detailDialogVisible = true;
    },
    handleDetailSearch () {
      this.detailTable.where = {
        typeId: this.currentTypeId,
        ...this.detailParams,
      };
      this.$refs.detailTable.reload();
    },
    handleDetailReset () {
      this.detailParams = { itemName: '', status: '' };
      this.detailTable.where = { typeId: this.currentTypeId };
      this.$refs.detailTable.reload();
    },
    handleDetailExport () {
      const params = {
        typeId: this.currentTypeId,
        ...this.detailParams,
      };
      exportItemDetails(params).then((res) => {
        let blob = new Blob([res.data], { type: 'application/octet-stream' });
        let link = document.createElement('a');
        link.style.display = 'none';
        link.href = URL.createObjectURL(blob);
        link.setAttribute('download', '资产物品详情.xlsx');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(link.href);
      });
    },
    // 固定资产合计
    getFixedSummary ({ columns, data }) {
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        if (['itemCount', 'inUseCount', 'unassignedCount', 'repairCount', 'scrapCount', 'lostCount'].includes(column.property)) {
          const total = data.reduce((sum, row) => sum + (row[column.property] || 0), 0);
          sums[index] = total;
        } else {
          sums[index] = '';
        }
      });
      return sums;
    },
    // 易耗品合计
    getConsumableSummary ({ columns, data }) {
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        if (['totalNum', 'remainingNum', 'useNum'].includes(column.property)) {
          const total = data.reduce((sum, row) => sum + (row[column.property] || 0), 0);
          sums[index] = total;
        } else {
          sums[index] = '';
        }
      });
      return sums;
    },
  },
};
</script>

<style scoped></style>
